<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Product
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.unit_in_liters"
                outlined
                label="Unit In Liter"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.quantity"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.code"
                outlined
                label="Code"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.code"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.hsn_code"
                outlined
                label="HSN Code"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.hsn_code"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.selling_price_per_unit"
                outlined
                label="Selling price per unit excludes tax"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.selling_price_per_unit"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="Product Category"
                outlined
                v-model="form.category_id"
                :items="productCategoryItems"
                label="Product Category"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.category_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.as_of_date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                    :error-messages="errors.as_of_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.as_of_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.original_price_per_unit"
                outlined
                label="Original Price Per Unit"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.original_price_per_unit"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.min_stock_qty"
                outlined
                label="Min Stock Qty"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.min_stock_qty"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.location"
                outlined
                label="location"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.location"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.tax_in_percent"
                outlined
                label="GST Tax"
                aria-placeholder="Enter Tax in %. Ex.18"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.tax_in_percent"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_point"
                inset
                :label="`Is Point: ${form.is_point ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_gift"
                inset
                :label="`Is Gift: ${form.is_gift ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_decimal"
                inset
                :label="`Is Decimal: ${form.is_decimal ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Product
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ProductCreatePage",
  data() {
    return {
      form: {
        unit_in_liters: 0,
        quantity: 0,
        name: "",
        is_point: 0,
        is_gift: 0,
        is_decimal: 0,
      },
      isLoading: false,
      productCategoryItems: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`products/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.product_categories.forEach((productCategory) => {
            this.productCategoryItems.push({
              id: productCategory.id,
              text: productCategory.description,
              value: productCategory.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/products", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/products");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
